
<div class="h-100">
    <d-contract-history
        v-model  = "history.show"
        :unit    = "history.unit"
        :history = "history.data"
        :contract= "contract"
    />

    <v-form class="h-100" ref="form">

        <c-flip-card
            v-model = "flipped"
            :top    = "8"
            :right  = "10"
            color   = "white--text"
            class   = "h-100"
        >
            <template v-slot:front>
                <div class="w-100 h-100">
                    <c-column-header
                        :label = "title"
                        class  = "primary mb-1 w-100"
                    >
                        <template v-slot:filter>
                            <div
                                v-if="edit && contract && contract.id"
                                class="v-flex"
                                style="margin-right: 30px; margin-top: -2px"
                            >
                                <c-toolbar-button
                                    v-if     = "!readonly"
                                    class    = "mr-1"
                                    color    = "white"
                                    icon     = "mdi-content-save"
                                    size     = "20"
                                    :tooltip = "$t('contract.edit.store')"
                                    @click   = "onStore"
                                />
                                <c-toolbar-button
                                    class    = "mr-1"
                                    color    = "white"
                                    :icon    = "readonly ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                    size     = "20"
                                    :tooltip = "readonly ? $t('contract.edit.off') : $t('contract.edit.on')"
                                    @click   = "onEdit"
                                />
                                <c-toolbar-button
                                    class    = "mr-1"
                                    v-if    = "contract"
                                    size    = "20"
                                    color   = "white"
                                    icon    = "mdi-history"
                                    tooltip = "Historie zum Vertrag"
                                    @click  = "onContractHistory"
                                />
                           </div>
                        </template>
                    </c-column-header>

                    <div class="lm-border pa-3 contract-content">
                        <p-site-contract-header
                            v-if="contract && contract.id"
                            :contract = "contract"
                            :readonly = "readonly"
                        />

                        <slot name="front" />
                    </div>
                </div>
            </template>
            <template v-slot:back>
                <div class="w-100 h-100">
                    <c-column-header
                        :label = "title"
                        class  = "primary mb-1 w-100"
                    />

                    <div class="lm-border pa-3 contract-content">
                        <p-site-contract-header
                            v-if      = "contract && contract.id"
                            :contract = "contract"
                            :readonly = "readonly"
                        />

                        <p-site-contract-payment
                            v-if        = "contract && contract.id"
                            :contract   = "contract"
                            class       = "mt-1"
                            style = "height: 194px"
                        />

                        <p-site-contract-toc
                            v-if      = "contract && contract.id"
                            :contract = "contract"
                            class     = "mt-1"
                        />
                    </div>
                </div>
            </template>
        </c-flip-card>
    </v-form>
</div>
